module.exports = __webpack_public_path__ + "staticVue/img/join_us03.af8c8e16.jpg";